import {makeAutoObservable, toJS} from "mobx";

class RoomStore {

    roomData = [];
    shopData = {};

    constructor() {
        makeAutoObservable(this)
    }

    getRoomData() {
        return toJS(this.roomData);
    }

    setRoomData(response) {
        const result = [...response];
        this.roomData = result;
    }

    setShopData(data) {
        this.shopData = data;
    }

    getShopData() {
        return toJS(this.shopData)
    }

    initValue() {
        this.roomData = [];
        this.shopData = {};
    }

}

let roomStore = new RoomStore()

export default roomStore